import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'completed-order-items-extra-fields',
    templateUrl: './completed.order.items.extra-fields.component.html',
    styleUrls: ['../../../completed.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CompletedOrderItemsExtraFieldsComponent {
    @Input('extraFields') extraFields: any;

    public prepareExtraFields() {
        return Object
            .keys(this.extraFields)
            .map(slug => this.extraFields[slug]);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/app/completed/order/items/extra-fields/completed.order.items.extra-fields.component.ts